import React from "react";
import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
const Card = ({ className = "", content, variant = "product", type }) => {
	const [expanded, setExpanded] = useState(false);

	const handleToggle = () => {
		setExpanded((prev) => !prev);
	};

	return (
		<>
			{variant === "homeSection7" && (
				<>
					{" "}
					<div className="w-[384px] h-[400px] relative">
						{/* 1st Main Div */}
						<div className="absolute w-[384px] h-[284px] top-[61px] rounded-[9.5px] bg-gradient-to-r from-[#B0D46D] to-[#193D34] shadow-[0px_34.76px_73.95px_0px_rgba(21,21,21,0.15)]"></div>

						{/* 2nd Main Div - Icon */}
						<div className="absolute w-[168px] h-[287px] left-[157.59px] bg-white rounded-full">
							<img
								loading="lazy"
								decoding="async"
								src={content.imageSrc}
								alt={content.imageAlt}
							/>
						</div>

						{/* 3rd Main Div */}
						<div className="absolute w-[196.38px] h-[275.78px] top-[124.22px] left-[32.54px] rounded-[6.33px] p-[16px_20px] bg-[#F1F6E9] shadow-[0px_22.9px_48.73px_0px_rgba(21,21,21,0.15)]">
							{/* 1st Sub Div - Logo */}
							<div className="w-full flex justify-center">
								<div className="w-[69.71px] h-[17.16px]">
									<img
										loading="lazy"
										decoding="async"
										src={content.logoPath}
										alt={content.logoAlt}
									/>
								</div>
							</div>
							{/* 2nd Sub Div */}
							<div className="w-[156.38px] h-[75px] mt-3">
								{/* Text 1 */}
								<div className="w-[148.38px] h-[51px] text-[#193D34] font-montserrat font-semibold text-[14px] leading-[100%]">
									{content.mainText}
								</div>
								{/* Text 2 */}
								<div className="w-[148.38px] h-[16px] text-[#47645D] font-montserrat font-normal text-[7.92px] leading-[15.83px]">
									{content.authorName}
								</div>
							</div>

							{/* 3rd Sub Div - Description */}
							<div className="w-[156.38px] h-[70px] text-[#47645D] font-montserrat font-normal text-[8px] leading-[100%]">
								{content.descriptionText}
							</div>

							{/* 4th Sub Div - Button/Icon */}
							<div className="w-full flex justify-center absolute bottom-[40px] left-1/2 transform -translate-x-1/2">
								<div className="w-[99.09px] h-[31.02px] p-[8px_12px] flex items-center justify-center gap-1">
									{[...Array(5)].map((_, i) => (
										<img
											loading="lazy"
											decoding="async"
											key={i}
											src={content.starIconPath}
											alt="Star Icon"
											className="w-4 h-4"
										/>
									))}
								</div>
							</div>
						</div>
						<button className="absolute top-[297px] left-[253px] w-[110px] h-[32px] rounded-[24px] font-montserrat font-medium text-[13px] leading-[24px] text-center text-[#F6F6F6] flex items-center justify-center gap-[2px] bg-[#193D34]">
							Read More
						</button>
					</div>
				</>
			)}
			{variant === "homeSection7Mobile" && (
				<div
					key={content.index}
					className="w-[306px] h-[318.75px] relative mx-auto"
				>
					{/* 1st Main Div */}
					<div className="absolute w-full h-[226px] top-[48px] rounded-[9.5px] bg-gradient-to-r from-[#B0D46D] to-[#193D34] shadow-[0px_34.76px_73.95px_0px_rgba(21,21,21,0.15)]"></div>

					{/* 2nd Main Div - Icon */}
					<div className="absolute w-[134px] h-[229px] left-[86px] bg-white rounded-full">
						<img
							loading="lazy"
							decoding="async"
							src={content.imageSrc}
							alt={content.imageAlt}
							className="w-full h-full object-contain"
						/>
					</div>

					{/* 3rd Main Div */}
					<div className="absolute w-[156px] h-[220px] top-[99px] left-[20px] rounded-[6.33px] p-[12px] bg-[#F1F6E9] shadow-[0px_22.9px_48.73px_0px_rgba(21,21,21,0.15)]">
						{/* Logo */}
						<div className="w-full flex justify-center">
							<div className="w-[56px] h-[14px]">
								<img
									loading="lazy"
									decoding="async"
									src={content.logoPath}
									alt={content.logoAlt}
									className="w-full h-full"
								/>
							</div>
						</div>

						{/* Text Content */}
						<div className="w-full h-[60px] mt-2">
							<div className="text-[#193D34] font-montserrat font-semibold text-[11px] leading-[100%]">
								{content.mainText}
							</div>
							<div className="text-[#47645D] font-montserrat font-normal text-[6px] leading-[12px]">
								{content.authorName}
							</div>
						</div>

						{/* Description */}
						<div className="w-full h-[56px] text-[#47645D] font-montserrat font-normal text-[6px] leading-[100%] mt-1">
							{content.descriptionText}
						</div>

						{/* Stars */}
						<div className="w-full flex justify-center absolute bottom-[20px] left-1/2 transform -translate-x-1/2">
							<div className="w-[80px] h-[25px] p-[6px] flex items-center justify-center gap-1">
								{[...Array(5)].map((_, i) => (
									<img
										loading="lazy"
										decoding="async"
										key={i}
										src={content.starIconPath}
										alt="Star Icon"
										className="w-3 h-3"
									/>
								))}
							</div>
						</div>
					</div>

					<button className="absolute top-[237px] left-[160px] w-[90px] h-[28px] rounded-[24px] font-montserrat font-medium text-[11px] leading-[20px] text-center text-[#F6F6F6] flex items-center justify-center gap-[2px] bg-[#193D34]">
						Read More
					</button>
				</div>
			)}
			{variant === "homeSection8Desktop" && (
				<div className="w-[33%] exact-1024:w-[32%] px-2 box-border">
					<div className="w-full bg-[#F1F6E9] h-auto flex flex-col gap-[16px] rounded-[8px] p-[16px_20px] box-border">
						{/* Image */}
						<div className="w-full h-[180px]">
							<img
								loading="lazy"
								decoding="async"
								src={content.imageSrc}
								alt={content.imageAlt}
								className="w-full h-full object-cover rounded-[8px]"
							/>
						</div>

						{/* Content */}
						<div className="w-full flex flex-col gap-[8px]">
							{/* Heading */}
							<div className="w-full">
								<p className="font-montserrat font-semibold text-[20px] leading-[28px] text-[#193D34]">
									{content.title}
								</p>
							</div>

							{/* Paragraph */}
							<div className="w-full">
								<p className="font-montserrat font-normal text-[16px] leading-[24px] text-[#17382F]">
									{content.description}
								</p>
							</div>

							{/* Icon Row */}
							<div className="w-full flex items-center gap-[8px]">
								<img
									loading="lazy"
									decoding="async"
									src={content.clockIcon}
									alt="Icon"
									className="w-[16px] h-[16px]"
								/>
								<span className="text-[#64748B] text-[14px]">|</span>
								<span className="font-montserrat font-normal text-[12px] leading-[16px] text-[#64748B]">
									{content.readTime}
								</span>
							</div>
						</div>

						{/* Button */}
						<div className="w-full h-[40px] flex items-center justify-center mt-auto rounded-[24px] border border-[#193D34] px-[10px]">
							<button className="w-full text-[13px] font-montserrat font-medium text-[#193D34]">
								Read More
							</button>
						</div>
					</div>
				</div>
			)}
			{variant === "homeSection8Mobile" && (
				<div
					key={content.index}
					className="w-[270px] bg-[#F1F6E9] h-[462px] flex flex-col gap-[16px] rounded-[8px] p-[16px]"
				>
					{/* Image */}
					<div className="w-full h-[160px]">
						<img
							loading="lazy"
							decoding="async"
							src={content.imageSrc}
							alt="Description"
							className="w-[230] h-[180] object-cover rounded-[8px]"
						/>
					</div>

					{/* Content */}
					<div className="w-[230px] h-[234px] flex flex-col gap-[8px]">
						<p className="font-montserrat font-semibold text-[18px] leading-[24px] text-[#193D34]">
							{content.title}
						</p>
						<br />
						<p className="font-montserrat font-normal text-[14px] leading-[20px] text-[#17382F]">
							{content.description}
						</p>
						<br />
						<div className="flex items-center gap-[8px]">
							<img
								loading="lazy"
								decoding="async"
								src={content.clockIcon}
								alt="Icon"
								className="w-[16px] h-[16px]"
							/>
							<span className="font-montserrat font-normal text-[12px] leading-[16px] text-[#64748B]">
								{content.readTime}
							</span>
						</div>
					</div>

					{/* Button */}
					<div className="w-[237px] h-[32px] flex items-center justify-center rounded-[24px] bg-transparent border border-[#193D34] mt-[8px]">
						<button className="font-montserrat font-medium text-[13px] leading-[24px] text-[#193D34]">
							Read More
						</button>
					</div>
				</div>
			)}
			{/* Product Card */}
			{variant === "product" && (
				<div
					className={`w-[360px] h-[479px] exact-1024:w-[300px]
                         ${
														variant === "dark"
															? "bg-gray-900 text-white"
															: "bg-[#F1F6E9] text-black"
													} rounded-lg  flex flex-col justify-between`}
				>
					<div>
						<div className="w-[360px] exact-1024:w-[300px] h-[183px]   overflow-hidden">
							<img
								loading="lazy"
								decoding="async"
								src={content.image}
								alt={content.title}
								className="w-[360px] h-[183px] max-w-full max-h-full"
							/>
						</div>

						<div className="w-[360px] exact-1024:w-[300px] h-[180px] p-4 flex flex-col gap-3">
							<div className="w-full h-[68px] p-2">
								<p className="text-[16px] font-medium">{content.title}</p>
							</div>
							<div className="w-full h-[96px] px-2 pb-1">
								<p className="text-[32px] font-semibold text-[#008500]">
									{content.price}
								</p>
								<p className="text-[13px] font-semibold text-[#008500]">
									{content.shipping}
								</p>
								<div className="flex flex-col items-end text-gray-700 text-[12px]">
									<p>{content.availability}</p>
									<img
										loading="lazy"
										decoding="async"
										src="/assets/home/section3/amazonLogo.svg"
										alt="amazonLog"
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="w-[360px] exact-1024:w-[300px] h-[100px] p-4 flex flex-col gap-2 p-5">
						<button className="w-full h-[40px] bg-[#193D34] text-white rounded-full">
							Compare
						</button>
						<button className="w-full h-[40px] border border-gray-300 rounded-full">
							View Details
						</button>
					</div>
				</div>
			)}
			{variant === "product_mobile" && (
				<div
					className={`w-[280px] h-[511px] ${
						variant === "dark"
							? "bg-gray-900 text-white"
							: "bg-white text-black"
					} rounded-lg shadow-lg p-2 flex flex-col justify-between`}
				>
					<div>
						{/* Image Section */}
						<div className="w-[280px] h-[183px]">
							<img
								loading="lazy"
								decoding="async"
								src={content.image}
								alt={content.title}
								className="w-full h-full object-cover rounded-t-lg"
							/>
						</div>

						{/* Content Section */}
						<div className="w-[280px] h-[180px] p-4 flex flex-col gap-3">
							{/* Title */}
							<div className="w-auto h-[68px] p-2">
								<p className="text-[16px] font-medium">{content.title}</p>
							</div>

							{/* Pricing & Shipping */}
							<div className="w-auto h-[96px] px-2 pb-1">
								<p className="text-[32px] font-semibold text-[#008500]">
									{content.price}
								</p>
								<p className="text-[13px] font-semibold text-[#008500]">
									{content.shipping}
								</p>

								{/* Availability & Amazon Logo */}
								<div className="flex items-center justify-between mt-2">
									<p className="text-gray-700 text-[12px]">
										{content.availability}
									</p>
									<img
										loading="lazy"
										decoding="async"
										src="/assets/home/section3/amazonLogo.svg"
										alt="Amazon Logo"
										className="w-[80px] h-auto" // Adjust width as needed
									/>
								</div>
							</div>
						</div>
					</div>

					{/* Buttons */}
					<div className="w-auto h-[100px] p-4 flex flex-col gap-2 p-5">
						<button className="w-full h-[40px] bg-[#193D34] text-white rounded-full">
							Compare
						</button>
						<button className="w-auto h-[40px] border border-gray-300 rounded-full">
							View Details
						</button>
					</div>
				</div>
			)}
			{variant === "product_details_mobile" && (
				<div
					className={`w-[280px] ${
						variant === "dark"
							? "bg-gray-900 text-white"
							: "bg-[#F1F6E9] text-black"
					} rounded-lg shadow-lg p-2 flex flex-col justify-between overflow-hidden h-auto`}
				>
					<div>
						{/* Image Section */}
						<div className="w-[280px] h-[183px]">
							<img
								loading="lazy"
								decoding="async"
								src={content.image}
								alt={content.title}
								className="w-full h-full object-cover rounded-t-lg"
							/>
						</div>

						{/* Content Section */}
						<div className="w-[280px] h-[180px] p-4 flex flex-col gap-3">
							{/* Title */}
							<div className="w-auto h-[68px] p-2">
								<p className="text-[16px] font-medium">{content.title}</p>
							</div>

							{/* Pricing & Shipping */}
							<div className="w-auto h-[96px] px-2 pb-1">
								<p className="text-[32px] font-semibold text-[#008500]">
									{content.price}
								</p>
								<p className="text-[13px] font-semibold text-[#008500]">
									{content.shipping}
								</p>

								{/* Availability & Amazon Logo */}
								<div className="flex items-center justify-between mt-2">
									<p className="text-gray-700 text-[12px]">
										{content.availability}
									</p>
									<img
										loading="lazy"
										decoding="async"
										src="/assets/home/section3/amazonLogo.svg"
										alt="Amazon Logo"
										className="w-[80px] h-auto"
									/>
								</div>
							</div>
						</div>
					</div>

					{/* Buttons */}
					<div className="w-auto p-4 flex flex-col gap-2">
						<button className="w-full h-[40px] bg-[#193D34] text-white rounded-full">
							Compare
						</button>
						<button className="w-auto h-[40px] border border-gray-300 rounded-full">
							View Details
						</button>
					</div>
				</div>
			)}

			{/* Feature Card */}
			{variant === "feature" && (
				<div
					className={`exact-1024:w-[30%] w-[360px] h-[320px] p-[24px] pr-[40px] pl-[40px] gap-[8px] rounded-[24px] bg-[#E8ECEB] shadow-md shadow-[#ABBED133] flex flex-col justify-center items-center ${className}`}
				>
					<div className="w-[280px] h-[168px] mb-4 flex flex-col gap-4 items-center">
						{content.image && (
							<img
								loading="lazy"
								decoding="async"
								src={content.image}
								alt="Feature Icon"
								className="w-[90px] h-[80px] max-w-[90px]"
							/>
						)}
						<p className="w-[280px] h-[72px] text-[28px] font-montserrat font-semibold leading-[32px] text-center text-[#47645D]">
							{content.title.split("\n").map((line, index) => (
								<React.Fragment key={index}>
									{line}
									<br />
								</React.Fragment>
							))}
						</p>
					</div>

					<div className="w-[280px] h-[68px] flex flex-col gap-2 items-center">
						<p className="text-[14px] font-montserrat font-normal leading-[100%] text-center text-[#657D77]">
							{content.description}
						</p>
					</div>
				</div>
			)}

			{variant === "categories" && (
				<div
					className={`w-[240px] h-[334px] rounded-[8px]  flex flex-col gap-[8px] shadow-lg bg-gray-200 ${className}`}
				>
					<div className="w-[240px] h-[230px]">
						{content.image && (
							<img
								loading="lazy"
								decoding="async"
								src={content.image}
								alt={content.title}
								className="w-full h-full object-cover rounded-t-[8px]"
							/>
						)}
					</div>

					<div className="w-[240px] h-[88px] px-[16px] pb-[16px] flex flex-col gap-[4px]">
						<p className="w-[209px] h-[24px] text-[#193D34] font-montserrat font-bold text-[20px] leading-[32px]">
							{content.title}
						</p>

						<p className="w-[209px] h-[12px] text-[#47645D] font-montserrat font-normal text-[12px] leading-[100%]">
							{content.description}
						</p>

						<p className="w-[209px] h-[12px] text-[#47645D] font-montserrat font-semibold text-[12px] leading-[100%]">
							{content.priceRange}
						</p>

						<p className="w-[209px] h-[12px] text-[#193D34] font-montserrat font-normal text-[12px] leading-[100%]">
							{content.category}
						</p>
					</div>
				</div>
			)}
			{variant === "categories_mobile" && (
				<div
					className={`w-[240px] h-[334px] rounded-[8px] flex flex-col gap-[8px] shadow-lg bg-gray-200 mx-auto ${className}`}
				>
					<div className="w-[240px] h-[230px]">
						{content.image && (
							<img
								loading="lazy"
								decoding="async"
								src={content.image}
								alt={content.title}
								className="w-full h-full object-cover rounded-t-[8px]"
							/>
						)}
					</div>

					<div className="w-[240px] h-[88px] px-[16px] pb-[16px] flex flex-col gap-[4px]">
						<p className="text-[#193D34] font-montserrat font-bold text-[20px] leading-[32px]">
							{content.title}
						</p>

						<p className="text-[#47645D] font-montserrat font-normal text-[12px] leading-[100%]">
							{content.description}
						</p>

						<p className="text-[#47645D] font-montserrat font-semibold text-[12px] leading-[100%]">
							{content.priceRange}
						</p>

						<p className="text-[#193D34] font-montserrat font-normal text-[12px] leading-[100%]">
							{content.category}
						</p>
					</div>
				</div>
			)}

			{variant === "faq" && (
				<div
					className={` md:pt-[80px] w-[240px] sm:w-[280px] md:w-[340px] h-[250px] sm:h-[300px] md:h-[350px] gap-[8px] rounded-[4px] pt-[16px] pr-[24px] pb-[16px] pl-[24px] flex flex-col border border-gray-200 ${content.backgroundColor} ${className} ${
						content.backgroundColor === "bg-[#657D77]"
							? "text-white"
							: "text-[#262A29]"
					}`}
				>
					{/* Header */}
					<div className="w-full flex items-center gap-[6px] pr-[8px] pl-[8px]">
						<img loading="lazy" decoding="async" src={content.icon} alt="faq" />
						<span>| {content.category}</span>
					</div>

					{/* Question & Answer Preview */}
					<div className="w-full flex flex-col gap-[12px]">
						<div className="text-[14px] sm:text-[15px] md:text-[16px] font-semibold leading-[120%] font-[Montserrat]">
							{content.question}
						</div>
						<div className="text-[13px] sm:text-[14px] font-normal leading-[140%] font-[Montserrat]">
							{content.answerPreview}
						</div>
						<div className="flex items-center gap-2">
							<img src={content.readTimeIcon} alt="clock" className="w-4 h-4" />
							<span className="text-[12px] font-normal font-[Montserrat]">
								Read Time: {content.readTime}
							</span>
						</div>
					</div>

					{/* Read More Button */}
					<div
						className={`w-full h-[32px] gap-[10px] rounded-[24px] pt-[8px] pr-[6px] pb-[8px] pl-[6px] border flex items-center justify-center mt-3 ${
							content.backgroundColor === "bg-[#657D77]"
								? "border-white"
								: "border-[#193D34]"
						}`}
					>
						<Link to="/faq">
							<button
								className={`w-full text-[13px] font-medium leading-[100%] text-center font-[Montserrat] ${
									content.backgroundColor === "bg-[#657D77]"
										? "text-white"
										: "text-[#193D34]"
								}`}
							>
								Read More
							</button>
						</Link>
					</div>
				</div>
			)}

			{/* Price Filter Card */}
			{variant === "priceFilter" && (
				<div
					className={`w-full max-w-[400px] xl:max-w-[540px] h-[479px] mx-auto ${
						variant === "dark"
							? "bg-gray-900 text-white"
							: "bg-[#F1F6E9] text-black"
					} rounded-lg shadow-lg flex flex-col justify-between shadow-[0px_4px_24px_#0000001F]`}
				>
					<div>
						{/* Image Section */}
						<div className="w-full max-w-[400px] xl:max-w-[480px] h-[183px] relative overflow-hidden flex items-center">
							<img
								loading="lazy"
								decoding="async"
								src={content.image}
								alt={content.title}
								className="w-full h-[183px] object-contain"
							/>

							{/* Icon Positioned on the Right Side */}
							<div className="absolute right-2 top-6 w-[64px] h-[24px] flex items-center justify-center rounded">
								<img
									loading="lazy"
									decoding="async"
									src={content.compareButtonIcon}
									alt={content.title}
									className="w-[64px] h-[24px]"
								/>
							</div>
						</div>

						{/* Content Section */}
						<div className="w-full max-w-[400px] xl:max-w-[480px] h-[180px] p-4 flex flex-col gap-3">
							<div className="w-full h-[68px] p-2">
								<p className="text-[16px] font-medium text-[#262A29]">
									{content.title}
								</p>
							</div>

							<div className="w-full h-[96px] px-2 pb-1 flex flex-col justify-end">
								{/* Price & Shipping */}
								<p className="text-[32px] font-semibold text-[#008500]">
									{content.price}
								</p>
								<p className="text-[13px] font-semibold text-[#008500]">
									{content.shipping}
								</p>

								{/* Availability & Amazon Logos */}
								<div className="flex justify-between items-end">
									{/* Left-aligned Amazon Logo */}
									<img
										loading="lazy"
										decoding="async"
										src="/assets/search/priceFilter/downButton.svg"
										alt="amazonLogCenter"
										className="ml-[35%]"
									/>

									{/* Right-aligned availability & Amazon Logo */}
									<div className="flex flex-col items-end text-gray-700 text-[12px]">
										<p>Available on</p>
										<img
											loading="lazy"
											decoding="async"
											src="/assets/home/section3/amazonLogo.svg"
											alt="amazonLogEnd"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* Button Section */}
					<div className="w-full max-w-[400px] xl:max-w-[480px] h-[100px] p-4 flex flex-col gap-2">
						<button className="w-full h-[40px] bg-[#193D34] text-white rounded-full">
							Compare
						</button>
						<button className="w-full h-[40px] border border-gray-300 rounded-full">
							View Details
						</button>
					</div>
				</div>
			)}

			{/* Price Filter Card */}
			{variant === "priceFilterMobile" && (
				<div
					className={`w-[260px] h-[511px] ${
						variant === "dark"
							? "bg-gray-900 text-white"
							: "bg-[#F1F6E9] text-black"
					} rounded-[8px] shadow-lg flex flex-col justify-between shadow-[0px_4px_24px_#0000001F]`}
				>
					<div>
						<div className="w-[260px] h-[183px] relative overflow-hidden flex items-center">
							{/* Image */}
							<img
								loading="lazy"
								decoding="async"
								src={content.image}
								alt={content.title}
								className="w-[260px] h-[183px] max-w-full max-h-full"
							/>

							{/* Icon Positioned on the Right Side */}
							<div className="absolute right-2 top-6 w-[64px] h-[24px] flex items-center justify-center  rounded">
								<img
									loading="lazy"
									decoding="async"
									src={content.compareButtonIcon}
									alt={content.title}
									className="w-[64px] h-[24px]"
								/>
							</div>
						</div>

						<div className="w-[260px] h-[180px] p-2 flex flex-col gap-3">
							<div className="w-full h-[68px] p-2">
								<p className="text-[16px] font-medium text-[#262A29]">
									{content.title}
								</p>
							</div>
							<div className="w-full h-[96px] px-2 pb-1 flex flex-col justify-end">
								{/* Price & Shipping */}
								<p className="text-[32px] font-semibold text-[#008500]">
									{content.price}
								</p>
								<p className="text-[13px] font-semibold text-[#008500]">
									{content.shipping}
								</p>

								{/* Availability & Amazon Logos */}
								<div className="flex justify-between items-end">
									{/* Left-aligned Amazon Logo */}
									<img
										loading="lazy"
										decoding="async"
										src="/assets/search/priceFilter/downButton.svg"
										alt="amazonLogCenter"
										className="ml-[35%]"
									/>

									{/* Right-aligned availability & Amazon Logo */}
									<div className="flex flex-col items-end text-gray-700 text-[12px]">
										<p>Available on</p>
										<img
											loading="lazy"
											decoding="async"
											src="/assets/home/section3/amazonLogo.svg"
											alt="amazonLogEnd"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="w-[260px] h-[100px] p-2 flex flex-col gap-2">
						<button className="w-full h-[40px] bg-[#193D34] text-white rounded-full">
							Compare
						</button>
						<button className="w-full h-[40px] border border-gray-300 rounded-full">
							View Details
						</button>
					</div>
				</div>
			)}

			{variant === "marketplaceCards" && (
				<div className="w-full h-[310px] rounded-[8px] bg-white overflow-hidden shadow-[0px_4px_24px_#0000001F]">
					{/* Top section with icon */}
					<div
						className="w-full h-[230px] rounded-t-[8px]  flex items-center justify-center"
						style={{ backgroundColor: content.bgColor }}
					>
						<div className="w-[159.28px] h-[48px] flex items-center justify-center">
							<img
								loading="lazy"
								decoding="async"
								src={content.icon}
								alt={content.title}
								className="w-full h-full object-contain"
							/>
						</div>
					</div>

					{/* Bottom text section */}
					<div className="p-4 bg-[#E8ECEB] h-[80px]">
						<h3 className="font-montserrat font-bold text-[20px] leading-[32px] text-[#193D34]">
							{content.title}
						</h3>
						<p className="font-montserrat font-normal text-[12px] leading-[12px] text-[#7A7A7A]">
							{content.productsCount}
						</p>
						<p className="font-montserrat font-semibold text-[12px] leading-[12px] text-[#7A7A7A]">
							{content.categories}
						</p>
					</div>
				</div>
			)}
			{variant === "marketplaceCards2" && (
				<div className="rounded-[8px] bg-white overflow-hidden shadow-lg">
					<div
						className="w-[440px] 1920:w-[580px] h-[210px] 2xl:h-[210px] rounded-t-[8px] flex items-center justify-center"
						style={{ backgroundColor: content.bgColor }}
					>
						<div className="w-[159.28px] h-[48px] flex items-center justify-center">
							<img
								loading="lazy"
								decoding="async"
								src={content.icon}
								alt={content.title}
								className="w-full h-full object-contain"
							/>
						</div>
					</div>
					<div className="p-4 bg-[#E8ECEB] h-[80px] 2xl:h-[90px]">
						<h3 className="font-montserrat font-bold text-[20px] leading-[32px] text-[#193D34] 2xl:text-[22px]">
							{content.title}
						</h3>
						<p className="font-montserrat font-normal text-[12px] leading-[12px] text-[#7A7A7A] 2xl:text-[14px]">
							{content.productsCount}
						</p>
						<p className="font-montserrat font-semibold text-[12px] leading-[12px] text-[#7A7A7A] 2xl:text-[14px]">
							{content.categories}
						</p>
					</div>
				</div>
			)}

			{variant === "topSellers" && (
				<div className="w-full h-[318px] flex flex-col gap-[18px] items-center justify-center rounded-[8px] p-[8px] bg-[#F1F6E9] shadow-sm">
					{/* Image/Icon Container */}
					<div className="w-[174px] h-[175px] rounded-[8px] bg-white flex items-center justify-center overflow-hidden">
						<img
							loading="lazy"
							decoding="async"
							src={content.image}
							alt="Product"
							className="w-full h-full object-contain"
						/>
					</div>

					{/* Text Content Container */}
					<div className="w-[174px] h-[79px] flex flex-col gap-[4px] px-[16px]">
						{/* Price */}
						<p className="font-montserrat font-semibold text-[20px] leading-[32px] text-[#262A29] text-center">
							{content.priceRange}
						</p>

						{/* Minimum Order */}
						<p className="font-montserrat font-normal text-[12px] leading-[12px] text-[#7A7A7A] text-center">
							Min. Order: {content.minOrder}
						</p>

						{/* Price Range */}
						<p className="font-montserrat font-semibold text-[12px] leading-[12px] text-[#7A7A7A] text-center">
							{content.shippingRange}
						</p>

						{/* Availability */}
						<div className="flex  items-center justify-center gap-1">
							<p className="font-montserrat font-normal text-[12px] leading-[12px] text-[#7A7A7A]">
								Available on
							</p>
							<img
								loading="lazy"
								decoding="async"
								src={content.platformIcon}
								alt={content.platformName}
								className="w-[48px] h-[22px]"
							/>
						</div>
					</div>

					{/* Button */}
					<button className="w-[174px] h-[32px] rounded-[24px] bg-[#B7D974] flex items-center justify-center gap-[2px] p-[8px] mt-auto">
						<span className="font-montserrat font-medium text-[13px] leading-[24px] text-[#193D34] text-center">
							Compare
						</span>
					</button>
				</div>
			)}

			{variant === "socialmediaCards" && (
				<div className="rounded-[8px] bg-white overflow-hidden shadow-lg">
					<div
						className="w-full h-[230px] 2xl:h-[270px] rounded-t-[8px] flex items-center justify-center"
						style={{ backgroundColor: content.bgColor }}
					>
						<div className="w-[159.28px] h-[48px] flex items-center justify-center">
							<img
								loading="lazy"
								decoding="async"
								src={content.icon}
								alt={content.title}
								className="w-full h-full object-contain"
							/>
						</div>
					</div>
					<div className="p-4 bg-[#E8ECEB] h-[80px] 2xl:h-[90px]">
						<h3 className="font-montserrat font-bold text-[20px] leading-[32px] text-[#193D34] 2xl:text-[22px]">
							{content.title}
						</h3>
						<p className="font-montserrat font-normal text-[12px] leading-[12px] text-[#7A7A7A] 2xl:text-[14px]">
							{content.productsCount}
						</p>
						<p className="font-montserrat font-semibold text-[12px] leading-[12px] text-[#7A7A7A] 2xl:text-[14px]">
							{content.categories}
						</p>
					</div>
				</div>
			)}
			{variant === "socialmediaCards2" && (
				<div className="rounded-[8px] bg-white overflow-hidden shadow-lg">
					<div
						className="w-[440px] 1920:w-[580px] h-[230px] 2xl:h-[270px] rounded-t-[8px] flex items-center justify-center"
						style={{ backgroundColor: content.bgColor }}
					>
						<div className="w-[159.28px] h-[48px] flex items-center justify-center">
							<img
								loading="lazy"
								decoding="async"
								src={content.icon}
								alt={content.title}
								className="w-full h-full object-contain"
							/>
						</div>
					</div>
					<div className="p-4 bg-[#E8ECEB] h-[80px] 2xl:h-[90px]">
						<h3 className="font-montserrat font-bold text-[20px] leading-[32px] text-[#193D34] 2xl:text-[22px]">
							{content.title}
						</h3>
						<p className="font-montserrat font-normal text-[12px] leading-[12px] text-[#7A7A7A] 2xl:text-[14px]">
							{content.productsCount}
						</p>
						<p className="font-montserrat font-semibold text-[12px] leading-[12px] text-[#7A7A7A] 2xl:text-[14px]">
							{content.categories}
						</p>
					</div>
				</div>
			)}
			{variant === "trendSimilarProducts" && (
				<div className="w-[170px] h-[275px] flex flex-col gap-[8px] rounded-[8px] p-[8px] bg-white shadow-sm">
					{/* Image/Icon Container */}
					<div className="w-[170px] h-[175px] rounded-[8px] bg-white flex items-center justify-center overflow-hidden">
						<img
							loading="lazy"
							decoding="async"
							src={content.image}
							alt="Product"
							className="w-full h-full object-contain"
						/>
					</div>

					{/* Text Content Container */}
					<div className="w-[170px] h-[92px] flex flex-col gap-[4px] px-[16px]">
						{/* Price */}
						<p className="font-montserrat font-semibold text-[20px] leading-[32px] text-[#262A29] text-center">
							{content.priceRange}
						</p>

						{/* Minimum Order */}
						<p className="font-montserrat font-normal text-[12px] leading-[12px] text-[#7A7A7A] text-center">
							Min. Order: {content.minOrder}
						</p>

						{/* Price Range */}
						<p className="font-montserrat font-semibold text-[12px] leading-[12px] text-[#7A7A7A] text-center">
							{content.shippingRange}
						</p>

						{/* Availability */}
						<div className="flex items-center justify-center gap-1">
							<p className="font-montserrat font-normal text-[12px] leading-[12px] text-[#7A7A7A]">
								Available on
							</p>
							<img
								loading="lazy"
								decoding="async"
								src={content.platformIcon}
								alt={content.platformName}
								className="w-[48px] h-[16px]"
							/>
						</div>
					</div>
				</div>
			)}
			{variant === "interestingArticles" && (
				<div className="relative w-[720px]  w-full h-[265px] object-contain">
					{/* Background Content Box */}
					<div className="absolute top-[13px] left-[230px] w-[400px] overflow-hidden h-[252px] bg-[#E9F2F4] rounded-[5px] p-8 flex flex-col justify-between">
						<div>
							<h3 className="font-semibold text-[13px] leading-[1] text-[#193D34] font-['Montserrat'] mb-10 whitespace-pre-line">
								{content.title}
							</h3>

							<p className="font-medium text-[13px] leading-[1] text-[#193D34] font-['Montserrat'] mb-4">
								{content.description}
							</p>
						</div>

						{/* Button and Date */}
						<div className="flex justify-between items-center">
							<button className="w-[112px] h-[28px] rounded-[24px] text-[13px] font-medium text-[#193D34] font-['Montserrat'] bg-[#B0D46D]">
								{content.buttonText}
							</button>
							<span className="text-[13px] font-medium text-[#193D34] font-['Montserrat']">
								{content.date}
							</span>
						</div>
					</div>

					{/* Image Overlapping on Top Left */}
					<div className="absolute top-10 left-0 w-[237px] h-[237px] rounded-[5px] overflow-hidden shadow-md">
						<img
							loading="lazy"
							decoding="async"
							src={content.imageSrc}
							alt="Article Visual"
							className="w-full h-full object-cover rounded-[5px]"
						/>
					</div>
				</div>
			)}
			{variant === "interestingArticlesMobile" && (
				<div className="flex flex-col w-full flex lg:hidden space-y-4">
					{/* Image on top */}
					<div className="w-full h-[200px] rounded-[5px] overflow-hidden shadow-md">
						<img
							loading="lazy"
							decoding="async"
							src={content.imageSrc}
							alt="Article Visual"
							className="w-full h-full object-cover rounded-[5px]"
						/>
					</div>

					{/* Content below image */}
					<div className="w-full bg-[#E9F2F4] rounded-[5px] p-4 flex flex-col justify-between">
						<div>
							<h3 className="font-semibold text-[13px] leading-[1] text-[#193D34] font-['Montserrat'] mb-4 whitespace-pre-line">
								{content.title}
							</h3>
							<p className="font-medium text-[13px] leading-[1] text-[#193D34] font-['Montserrat'] mb-4">
								{content.description}
							</p>
						</div>

						{/* Button and Date */}
						<div className="flex justify-between items-center">
							<button className="w-[112px] h-[28px] bg-white rounded-[24px] text-[13px] font-medium text-[#193D34] font-['Montserrat']">
								{content.buttonText}
							</button>
							<span className="text-[13px] font-medium text-[#193D34] font-['Montserrat']">
								{content.date}
							</span>
						</div>
					</div>
				</div>
			)}
			{variant === "blogStoryCardTemplate1" && (
				<div className="grid md:grid-cols-[644px_476px] grid-cols-1 flex-shrink-0 gap-4">
					{/* Image */}
					<div className="h-[378px] rounded-[5px] overflow-hidden shadow-md">
						<img
							loading="lazy"
							decoding="async"
							src={content.imageUrl}
							alt={content.title}
							className="w-full h-full object-cover rounded-[5px]"
						/>
					</div>

					{/* Content */}
					<div className="h-[378px] bg-[#E9F2F4] rounded-[5px] p-6 flex flex-col justify-between">
						<div>
							<h3 className="font-['Montserrat'] text-[16px] font-bold text-[#193D34] mb-10 whitespace-pre-line">
								{content.title}
							</h3>
							<p className="font-['Montserrat'] text-[14px] font-medium text-[#193D34] leading-[1.5]">
								{content.description}
							</p>
						</div>
						<div className="flex justify-between items-center mt-6">
							<Link to="/blog-details">
								<button className="w-[113px] h-[32px] bg-primary rounded-[24px] px-4 py-1 text-[13px] font-medium font-['Montserrat'] text-[#193D34] shadow-sm">
									{content.buttonLabel}
								</button>
							</Link>
							<span className="text-[13px] font-medium font-['Montserrat'] text-[#193D34] text-right align-middle">
								{content.date}
							</span>
						</div>
					</div>
				</div>
			)}
			{variant === "blogStoryCardTemplate2" && (
				<div className="grid md:grid-cols-[476px_644px] grid-cols-1 flex-shrink-0 gap-4">
					{/* Content */}
					<div className="h-[378px] bg-[#E9F2F4] rounded-[5px] p-6 flex flex-col justify-between">
						<div>
							<h3 className="font-['Montserrat'] text-[16px] font-bold text-[#193D34] mb-10">
								{content.title}
							</h3>
							<p className="font-['Montserrat'] text-[14px] font-medium text-[#193D34] leading-[1.5]">
								{content.description}
							</p>
						</div>
						<div className="flex justify-between items-center mt-6">
							<button className="w-[113px] h-[32px] bg-primary rounded-[24px] px-4 py-1 text-[13px] font-medium font-['Montserrat'] text-[#193D34] shadow-sm">
								{content.buttonLabel}
							</button>
							<span className="text-[13px] font-medium font-['Montserrat'] text-[#193D34] text-right align-middle">
								{content.date}
							</span>
						</div>
					</div>

					{/* Image */}
					<div className="h-[378px] rounded-[5px] overflow-hidden shadow-md">
						<img
							loading="lazy"
							decoding="async"
							src={content.imageUrl}
							alt={content.title}
							className="w-full h-full object-cover rounded-[5px]"
						/>
					</div>
				</div>
			)}
			{variant === "privacy" && (
				<div className="w-full">
					<div
						className={`flex items-center justify-between px-4 py-3 rounded-md cursor-pointer transition-colors duration-300 ${
							expanded ? "bg-[#B0D46D]" : "bg-[#193D34]"
						}`}
						onClick={handleToggle}
					>
						<h3
							className={`text-sm whitespace-pre-line font-semibold transition-colors duration-300 ${
								expanded ? "text-[#193D34]" : "text-[#B0D46D]"
							}`}
						>
							{content.title}
						</h3>
						<ChevronDown
							className={`w-5 h-5 transform transition-transform duration-300 ${
								expanded ? "rotate-180 text-[#193D34]" : "text-[#B0D46D]"
							}`}
						/>
					</div>

					<div
						className={`transition-all duration-500 overflow-hidden ${
							expanded ? "max-h-[1000px] mt-4" : "max-h-0"
						}`}
					>
						<div className="bg-[#E9F2F4] p-5 rounded-md space-y-2 text-sm text-gray-800">
							<p>{content.content}</p>

							{content.sub?.length > 0 &&
								content.sub.map((item, index) => (
									<div key={`sub-${index}`}>
										<p className="ml-2 mt-2 font-semibold">{item.title}</p>
										{item.contents.map((subContent, index1) => (
											<p className="ml-6" key={`subContent-${index1}`}>
												{subContent}
											</p>
										))}
									</div>
								))}

							{content.details?.length > 0 &&
								content.details.map((item, index) => (
									<p key={`details-${index}`} className="ml-2 mt-2">
										{item}
									</p>
								))}
						</div>
					</div>
				</div>
			)}
			{variant === "dropshipping" && (
				<div className="grid md:grid-cols-2 grid-cols-1 gap-10 items-center">
					{/* Image */}
					<div className="flex justify-center items-center">
						<div className="max-w-[332px] w-full rounded-[5px] overflow-hidden">
							<img
								loading="lazy"
								decoding="async"
								src={content.imageUrl}
								alt={content.title}
								className="w-full object-cover rounded-[5px]"
							/>
						</div>
					</div>

					{/* Content */}
					<div className="rounded-[5px] p-6 flex flex-col justify-center">
						{content.contentBox.map((item, index) => (
							<div className="mb-6" key={index}>
								<h3 className="font-['Montserrat'] text-[13px] font-bold text-[#193D34] mb-4 whitespace-pre-line">
									{item.title}
								</h3>
								<p className="font-['Montserrat'] text-[13px] font-medium text-[#193D34] leading-[1.5] whitespace-pre-line">
									{item.description}
								</p>
							</div>
						))}
					</div>
				</div>
			)}

			{variant === "dropshipping2" && (
				<div className="grid md:grid-cols-2 grid-cols-1 gap-10 items-center">
					{type?.toLowerCase() === "mobile" ? (
						<>
							{/* Image first */}
							<div className="flex justify-center items-center">
								<div className="max-w-[437px] w-full rounded-[5px] overflow-hidden shadow-md">
									<img
										loading="lazy"
										decoding="async"
										src={content.imageUrl}
										alt={content.title}
										className="w-full object-cover rounded-[5px]"
									/>
								</div>
							</div>

							{/* Content second */}
							<div className="rounded-[5px] p-6 flex flex-col justify-center">
								{content.contentBox.map((item, index) => (
									<div className="mb-4" key={index}>
										<h3 className="font-['Montserrat'] text-[13px] font-bold text-[#193D34] mb-4 whitespace-pre-line">
											{item.title}
										</h3>
										<p className="font-['Montserrat'] text-[13px] font-medium text-[#193D34] leading-[1.5] whitespace-pre-line">
											{item.description}
										</p>
									</div>
								))}
							</div>
						</>
					) : type?.toLowerCase() === "desktop" ? (
						<>
							{/* Content first */}
							<div className="rounded-[5px] p-6 flex flex-col justify-center">
								{content.contentBox.map((item, index) => (
									<div className="mb-4" key={index}>
										<h3 className="font-['Montserrat'] text-[13px] font-bold text-[#193D34] mb-4 whitespace-pre-line">
											{item.title}
										</h3>
										<p className="font-['Montserrat'] text-[13px] font-medium text-[#193D34] leading-[1.5] whitespace-pre-line">
											{item.description}
										</p>
									</div>
								))}
							</div>

							{/* Image second */}
							<div className="flex justify-center items-center">
								<div className="max-w-[437px] w-full rounded-[5px] overflow-hidden shadow-md">
									<img
										loading="lazy"
										decoding="async"
										src={content.imageUrl}
										alt={content.title}
										className="w-full object-cover rounded-[5px]"
									/>
								</div>
							</div>
						</>
					) : null}
				</div>
			)}

			{variant === "home_section7" && (
				<>
					{" "}
					<div className="w-[384px] h-[400px] relative">
						{/* 1st Main Div */}
						<div className="absolute w-[384px] h-[284px] top-[61px] rounded-[9.5px] bg-gradient-to-r from-[#B0D46D] to-[#193D34] shadow-[0px_34.76px_73.95px_0px_rgba(21,21,21,0.15)]"></div>

						{/* 2nd Main Div - Icon */}
						<div className="absolute w-[168px] h-[287px] left-[157.59px] bg-white rounded-full">
							<img
								loading="lazy"
								decoding="async"
								src={content.imageSrc}
								alt={content.imageAlt}
							/>
						</div>

						{/* 3rd Main Div */}
						<div className="absolute w-[196.38px] h-[275.78px] top-[124.22px] left-[32.54px] rounded-[6.33px] p-[16px_20px] bg-[#F1F6E9] shadow-[0px_22.9px_48.73px_0px_rgba(21,21,21,0.15)]">
							{/* 1st Sub Div - Logo */}
							<div className="w-full flex justify-center">
								<div className="w-[69.71px] h-[17.16px]">
									<img
										loading="lazy"
										decoding="async"
										src={content.logoPath}
										alt={content.logoAlt}
									/>
								</div>
							</div>
							{/* 2nd Sub Div */}
							<div className="w-[156.38px] h-[75px] mt-3">
								{/* Text 1 */}
								<div className="w-[148.38px] h-[51px] text-[#193D34] font-montserrat font-semibold text-[14px] leading-[100%]">
									{content.mainText}
								</div>
								{/* Text 2 */}
								<div className="w-[148.38px] h-[16px] text-[#47645D] font-montserrat font-normal text-[7.92px] leading-[15.83px]">
									{content.authorName}
								</div>
							</div>

							{/* 3rd Sub Div - Description */}
							<div className="w-[156.38px] h-[70px] text-[#47645D] font-montserrat font-normal text-[8px] leading-[100%]">
								{content.descriptionText}
							</div>

							{/* 4th Sub Div - Button/Icon */}
							<div className="w-full flex justify-center absolute bottom-[40px] left-1/2 transform -translate-x-1/2">
								<div className="w-[99.09px] h-[31.02px] p-[8px_12px] flex items-center justify-center gap-1">
									{[...Array(5)].map((_, i) => (
										<img
											loading="lazy"
											decoding="async"
											key={i}
											src={content.starIconPath}
											alt="Star Icon"
											className="w-4 h-4"
										/>
									))}
								</div>
							</div>
						</div>
						<button className="absolute top-[297px] left-[253px] w-[110px] h-[32px] rounded-[24px] font-montserrat font-medium text-[13px] leading-[24px] text-center text-[#F6F6F6] flex items-center justify-center gap-[2px] bg-[#193D34]">
							Read More
						</button>
					</div>
				</>
			)}
		</>
	);
};

export default Card;
